import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const RxMenu = () => (
	<a href={'#/rx'}><Trans>Status</Trans></a>
);
